module.exports = __webpack_public_path__ + "a0a24b40.woff2";